import { useCallback } from 'react';

import { getCoachPendoTrigger } from 'bundles/ai-course-coach/utils/pendo';
import { useCourseToolBarPlugins } from 'bundles/course-v2/components/navigation/CourseToolBar/useCourseToolBarPlugins';

/**
 * A hook to handle UI actions for Coach Tutor when a new message is triggered.
 */
export const useCoachTutorMessageUIActions = ({
  shouldTrigger = true,
  skipPendo = false,
}: {
  shouldTrigger?: boolean;
  skipPendo?: boolean;
}) => {
  const { setToolSelected, setExpanded } = useCourseToolBarPlugins();

  const onTriggerMessage = useCallback<() => void>(() => {
    if (!shouldTrigger) {
      return;
    }

    setToolSelected('coach');
    setExpanded(true);

    if (!skipPendo) {
      // for each message sent, conditionally trigger the pendo guide
      const coachPendoTriggerInstance = getCoachPendoTrigger({});
      coachPendoTriggerInstance.handleNewMessage();
    }
  }, [setToolSelected, setExpanded, shouldTrigger, skipPendo]);

  return {
    onTriggerMessage,
  };
};
